// @flow strict
const PROFILE_ITEMS = Object.freeze({
    general: 'GENERAL',
    authorization: 'AUTHORIZATION',
});

export default PROFILE_ITEMS;

export type ProfileItemsType = $Values<typeof PROFILE_ITEMS>;
